import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { Vue, Component } from 'vue-property-decorator';
import Localization from './localization/localization';

@Component({
    name: 'settings',
    components: {
        'material-icons': GoogleMaterialIcon,
        'localization': Localization,
    },
})

export default class Settings extends Vue {

}
